var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"sh-v-owl-carousel"},[_c('div',{ref:"elementHandleRef",staticClass:"owl-carousel owl-theme"},[_vm._t("default")],2),_c('span',{ref:"prevHandlerRef"},[_vm._t("prev")],2),_c('span',{ref:"nextHandlerRef"},[_vm._t("next")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }